<template>
  <div class="page-heading" :class="{'border': bottomBorder}">

    <div class="side-btn">
      <button @click.prevent="togleFavoriteSidebar">
        <img v-if="!isRadioStation" src="~assets/images/icons/tv-1.png" alt="">
        <img v-if="isRadioStation" src="~assets/images/icons/radio-1.png" alt="">
      </button>
      <p>{{ this.favoriteLabel }}</p>
    </div>

    <div class="container">

      <ul class="buttons" v-if="selectedRadioCategory && selectedTvCategory">
        <li v-for="(button, index) in buttons" :key="index">
          <button :class="{active: button.isActive}" @click.stop.prevent="action(button.name)">
            <span>{{ $t(button.title) }}</span>
          </button>
        </li>
      </ul>

      <button v-if="isTvGuide" class="calendar-btn" @click.prevent="openCalendar">
        <span class="calendar-btn-text">{{ calendarDayRelative }}</span>
        <i>
          <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300.000000 324.000000"><g transform="translate(0.000000,324.000000) scale(0.050000,-0.050000)" stroke="none"><path d="M735 6449 c-345 -84 -623 -365 -705 -714 -44 -188 -44 -4802 0 -4990 84 -354 361 -631 715 -715 187 -44 4323 -44 4510 0 354 84 631 361 715 715 25 107 29 474 29 2495 0 2021 -4 2388 -29 2495 -84 354 -361 631 -715 715 -180 42 -4343 42 -4520 -1z m4735 -246 c257 -117 289 -212 290 -868 l0 -535 -2760 0 -2760 0 0 535 c1 656 33 751 290 868 125 56 4815 56 4940 0z m290 -3618 c-1 -2207 9 -2053 -142 -2203 -151 -152 54 -141 -2614 -142 -2593 0 -2439 -7 -2593 111 -38 29 -92 98 -120 155 l-51 102 0 1976 0 1976 2760 0 2760 0 0 -1975z"/><path d="M1558 5714 c-134 -90 -153 -248 -43 -359 192 -191 506 49 366 279 -76 124 -209 157 -323 80z"/><path d="M4198 5714 c-37 -25 -79 -67 -92 -95 -133 -263 261 -465 415 -213 126 207 -122 444 -323 308z"/></g></svg>
          <span class="calendar-btn-num">{{ calendarDayNum }}</span>
        </i>
      </button>

      <a v-if="isTvGuide" class="list-btn" @click.prevent="toggleView">
        <svg v-if="isListView" version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300.000000 300.000000"><g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M135 2976 c-60 -28 -87 -56 -114 -116 -20 -43 -21 -63 -21 -546 0 -554 0 -557 63 -622 18 -19 49 -42 70 -53 36 -19 60 -19 570 -17 l533 3 42 28 c23 15 54 46 69 69 l28 42 3 533 c2 512 2 534 -17 571 -26 51 -91 108 -138 121 -24 7 -216 11 -538 11 l-500 0 -50 -24z m1135 -671 l0 -575 -575 0 -575 0 0 575 0 575 575 0 575 0 0 -575z"/><path d="M1766 2985 c-47 -16 -101 -67 -127 -118 -19 -36 -19 -60 -17 -570 l3 -533 28 -42 c15 -23 46 -54 69 -69 l42 -28 533 -3 c510 -2 534 -2 570 17 21 11 52 34 70 53 63 65 63 68 63 622 l0 501 -24 50 c-28 60 -56 87 -116 114 -43 20 -63 21 -550 20 -404 0 -513 -3 -544 -14z m1114 -680 l0 -575 -575 0 -575 0 0 575 0 575 575 0 575 0 0 -575z"/><path d="M135 1361 c-22 -10 -54 -34 -72 -52 -63 -66 -63 -69 -63 -623 0 -483 1 -503 21 -546 27 -60 54 -88 114 -116 l50 -24 500 0 c322 0 514 4 538 11 47 13 112 70 138 121 19 37 19 59 17 571 l-3 533 -28 42 c-15 23 -46 54 -69 69 l-42 28 -530 2 c-501 3 -533 2 -571 -16z m1135 -666 l0 -575 -575 0 -575 0 0 575 0 575 575 0 575 0 0 -575z"/><path d="M1743 1359 c-48 -23 -89 -67 -110 -116 -10 -26 -13 -139 -13 -553 0 -495 1 -523 19 -559 26 -50 91 -107 138 -120 24 -7 216 -11 538 -11 l500 0 50 24 c60 28 87 56 114 116 20 43 21 63 21 546 0 554 0 557 -63 623 -69 72 -52 71 -632 71 -509 0 -521 0 -562 -21z m1137 -664 l0 -575 -575 0 -575 0 0 575 0 575 575 0 575 0 0 -575z"/></g></svg>
        <svg v-else version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 389.000000 406.000000"><g transform="translate(0.000000,406.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M175 4047 c-118 -47 -184 -148 -172 -262 15 -150 155 -256 297 -227 102 22 180 100 202 202 21 105 -36 221 -136 272 -48 25 -148 33 -191 15z"/><path d="M1012 3808 l3 -83 1438 -3 1437 -2 0 85 0 85 -1440 0 -1441 0 3 -82z"/><path d="M188 2866 c-48 -13 -62 -21 -111 -65 -66 -59 -93 -170 -63 -256 21 -64 57 -109 114 -142 40 -24 58 -28 122 -28 84 0 127 16 179 67 153 150 65 404 -149 431 -25 3 -66 0 -92 -7z"/><path d="M1017 2703 c-4 -3 -7 -42 -7 -85 l0 -78 1440 0 1440 0 0 85 0 85 -1433 0 c-789 0 -1437 -3 -1440 -7z"/><path d="M166 1676 c-57 -21 -108 -67 -136 -122 -33 -65 -35 -169 -3 -230 26 -48 82 -100 132 -122 57 -24 147 -19 208 11 188 96 184 362 -6 453 -47 23 -145 28 -195 10z"/><path d="M1012 1438 l3 -83 1438 -3 1437 -2 0 85 0 85 -1440 0 -1441 0 3 -82z"/><path d="M172 491 c-105 -36 -166 -123 -167 -236 0 -106 48 -184 141 -231 55 -27 165 -26 220 3 79 42 144 145 144 228 0 99 -85 211 -181 239 -67 20 -91 20 -157 -3z"/><path d="M1017 333 c-4 -3 -7 -42 -7 -85 l0 -78 1440 0 1440 0 0 85 0 85 -1433 0 c-789 0 -1437 -3 -1440 -7z"/></g></svg>
      </a>

    </div>
    <!-- <guide-svg-sprite /> -->
  </div>
</template>

<script>
// import GuideSvgSprite from 'components/svg-sprites/GuideSvgSprite'
import { mapState, mapMutations } from 'vuex'
import DateTimeHelper from 'helpers/date'

export default {
  name: 'PageHeading',
  // components: {
  //   GuideSvgSprite
  // },
  props: {
    buttons: Array,
    action: Function,
    partsOfDay: Object,
    isListView: Boolean,
    toggleView: Function,
    isRadioStation: {
      type: Boolean,
      default: false
    },
    bottomBorder: Boolean
  },
  computed: {
    ...mapState({
      selectedTvCategory: state => state.guide.selectedTvCategory,
      selectedRadioCategory: state => state.guide.selectedRadioCategory,
      calendarDay: state => state.guide.calendarDay
    }),
    isTvGuide: function () {
      return this.$route.name === 'Guide'
    },
    favoriteLabel: function () {
      const radioName = this.selectedRadioCategory ? this.selectedRadioCategory.name : ''
      const tvName = this.selectedTvCategory ? this.selectedTvCategory.name : ''
      return this.isRadioStation ? radioName : tvName
    },
    calendarDayRelative: function () {
      if (!this.calendarDay) {
        return this.$t('guide_calendar_date_today')
      } else {
        return DateTimeHelper.getRelative(this.calendarDay, {})
      }
    },
    calendarDayNum: function () {
      if (!this.calendarDay) {
        return DateTimeHelper.nowStringLocal('DD')
      } else {
        return DateTimeHelper.format(this.calendarDay, 'DD')
      }
    }
  },
  methods: {
    ...mapMutations([
      'TOGGLE_FAVORITE_SIDEBAR',
      'SET_MODAL_TYPE',
      'SET_MODAL_DATA',
      'UPDATE_SHOW_MODAL'
    ]),
    togleFavoriteSidebar: function () {
      this.TOGGLE_FAVORITE_SIDEBAR()
    },
    openCalendar: function () {
      this.SET_MODAL_TYPE('calendar')
      this.SET_MODAL_DATA(this.partsOfDay)
      this.UPDATE_SHOW_MODAL(true)
    }
  }
}

</script>

<style scoped lang="scss">
@import 'uc/_variables';

.page-heading {
    height: $headingheight;
    background: rgb(238, 238, 238);
    border-bottom: 1px solid transparent;
    position: relative;
        &.border {
            border-bottom: 1px solid rgb(209, 209, 209);
        }
}
.container {
    height: 100%;
    text-align: center;
    position: relative;
}
.side-btn {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;

    &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%;
    }
    button {
        vertical-align: middle;
        width: 50px;
        height: 40px;
        margin: -1px 13px 0 -5px;
        padding: 0;
        background: linear-gradient(rgb(0, 172, 223) 0%, rgb(0, 103, 155) 100%);
        border: 0;
        border-radius: 0 4px 4px 0;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.3);
        transition: transform 0.3s ease;

        img {
            display: inline-block;
            vertical-align: middle;
            width: 24px;
            height: 24px;
        }
        &:hover {
            transform: translateX(5px);
        }
    }
    p {
        display: inline-block;
        vertical-align: middle;
        max-width: 240px;
        line-height: 30px;
        height: 30px;
        margin-bottom: 0;
        padding-left: 10px;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
        color: rgb(50, 62, 67);
        border-left: 1px solid rgb(208, 208, 208);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.buttons {
    display: inline-block;
    height: 100%;

    &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%;
    }
    li {
        display: inline-block;
        vertical-align: middle;
    }
    button {
        min-width: 150px;
        margin: 0 8px;
        padding: 5px 10px;
        font-size: 14px;
        font-weight: 500;
        background: #ffffff;
        color: rgb(50, 62, 67);
        border-radius: 4px;
        box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);
        overflow: hidden;
        position: relative;

        &:before {
            content: '';
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(rgb(0, 172, 223) 0%, rgb(0, 103, 155) 100%);
            transition: opacity 0.3s ease;
        }
        span {
            position: relative;
        }
        &:hover,
        &.active {
            color: rgb(255, 255, 255);

            &:before {
                opacity: 1;
            }
        }
    }
}
.calendar-btn {
    vertical-align: middle;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 55px;
    height: 32px;
    line-height: 29px;
    margin: 0;
    padding: 0 60px 0 30px;
    font-size: 14px;
    font-weight: normal;
    color: rgb(0, 149, 218);
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(228, 228, 228);
    border-radius: 5px;
    box-shadow: 0px 0 30px 0px rgba(0, 0, 0, 0.1);

    i, svg {
        display: inline-block;
        vertical-align: middle;
    }
    i {
        position: absolute;
        top: 0;
        right: 0;
        width: 40px;
        height: 100%;
        border-left: 1px solid rgb(193, 196, 197);
    }
    svg {
        width: 20px;
        transition: fill 0.3s ease;
    }
    &:hover {
        .calendar-btn-num {
            color: rgb(0, 149, 218);
        }
        svg {
            fill: currentColor
        }
    }
}
.calendar-btn-text, .calendar-btn-num {
    display: inline-block;
    vertical-align: middle;
}
.calendar-btn-num {
    position: absolute;
    top: 4px;
    left: 0;
    right: 0;
    font-size: 11px;
    color: rgb(0, 0, 0);
    transition: color 0.3s ease;
}
.list-btn {
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    top: 16px;
    right: 0;
    width: 40px;
    height: 32px;
    background: #ffffff;
    box-shadow: 0px 0 30px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid rgb(228, 228, 228);
    border-radius: 5px;
    cursor: pointer;
    overflow: hidden;

    &:before {
        content: '';
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(rgb(0, 172, 223) 0%, rgb(0, 103, 155) 100%);
        transition: opacity 0.3s ease;
    }
    svg {
        display: inline-block;
        vertical-align: middle;
        pointer-events: none;
        width: 19px;
        height: 20px;
        margin-top: 5px;
        position: relative;
    }
    &:hover {
        &:before {
            opacity: 1;
        }
        svg {
            fill: #ffffff;
        }
    }
}

@media only screen and (min-width: $breakpoint4) {
    .calendar-btn {
        right: 97px;
    }
    .list-btn {
        right: 42px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeading.vue